var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade"},[_c('div',{staticClass:"app-modal"},[(_vm.waiting)?_c('div',[_c('app-spinner')],1):_c('div',{staticClass:"app-modal__body"},[_vm._t("body")],2),_c('div',{staticClass:"app-modal__footer"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }